// enriched_selector_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "option",
    "phoneForm",
    "addressForm",
    "phoneSelect",
    "addressSelect",
    "submitButton",
    "phoneButton",
    "addressButton",
  ];

  connect() {
    // On initial load, check if a form is visible and set the corresponding button state
    if (
      this.hasPhoneFormTarget &&
      !this.phoneFormTarget.classList.contains("hidden")
    ) {
      this.setPhoneButtonActive();
    }

    if (
      this.hasAddressFormTarget &&
      !this.addressFormTarget.classList.contains("hidden")
    ) {
      this.setAddressButtonActive();
    }
  }

  showPhoneForm(event) {
    event.preventDefault();
    if (this.hasPhoneFormTarget) {
      if (this.phoneFormTarget.classList.contains("hidden")) {
        this.phoneFormTarget.classList.remove("hidden");
        this.addressFormTarget.classList.add("hidden");

        // Set active state on phone button and remove from address button
        this.setPhoneButtonActive();
        this.setAddressButtonInactive();
      } else {
        this.phoneFormTarget.classList.add("hidden");
        this.setPhoneButtonInactive();
      }
      this.disableSubmitButton();
    }
  }

  showAddressForm(event) {
    event.preventDefault();
    if (this.hasAddressFormTarget) {
      if (this.addressFormTarget.classList.contains("hidden")) {
        this.addressFormTarget.classList.remove("hidden");
        this.phoneFormTarget.classList.add("hidden");

        // Set active state on address button and remove from phone button
        this.setAddressButtonActive();
        this.setPhoneButtonInactive();
      } else {
        this.addressFormTarget.classList.add("hidden");
        this.setAddressButtonInactive();
      }
      this.disableSubmitButton();
    }
  }

  setPhoneButtonActive() {
    if (this.hasPhoneButtonTarget) {
      this.phoneButtonTarget.classList.add("bg-green-50", "border-green-300");
      this.phoneButtonTarget.classList.remove("bg-white", "border-[#C2C8CA]");
    }
  }

  setPhoneButtonInactive() {
    if (this.hasPhoneButtonTarget) {
      this.phoneButtonTarget.classList.remove(
        "bg-green-50",
        "border-green-300",
      );
      this.phoneButtonTarget.classList.add("bg-white", "border-[#C2C8CA]");
    }
  }

  setAddressButtonActive() {
    if (this.hasAddressButtonTarget) {
      this.addressButtonTarget.classList.add("bg-green-50", "border-green-300");
      this.addressButtonTarget.classList.remove("bg-white", "border-[#C2C8CA]");
    }
  }

  setAddressButtonInactive() {
    if (this.hasAddressButtonTarget) {
      this.addressButtonTarget.classList.remove(
        "bg-green-50",
        "border-green-300",
      );
      this.addressButtonTarget.classList.add("bg-white", "border-[#C2C8CA]");
    }
  }

  phoneSelectionChanged(event) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];

    if (select.value) {
      // Update phone number hidden field
      document.getElementById("phone_number_selected").value = select.value;

      // Clear address fields
      document.getElementById("address_line_1").value = "";
      document.getElementById("city").value = "";
      document.getElementById("state").value = "";
      document.getElementById("postal_code").value = "";

      // Enable the submit button
      this.enableSubmitButton();
    } else {
      this.disableSubmitButton();
    }
  }

  addressSelectionChanged(event) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];

    if (select.value) {
      const [address, city, state, postalCode] = select.value.split("|");

      // Update address hidden fields
      document.getElementById("address_line_1").value = address;
      document.getElementById("city").value = city;
      document.getElementById("state").value = state;
      document.getElementById("postal_code").value = postalCode;

      // Clear phone number field
      document.getElementById("phone_number_selected").value = "";

      // Enable the submit button
      this.enableSubmitButton();
    } else {
      this.disableSubmitButton();
    }
  }

  enableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove(
        "opacity-50",
        "cursor-not-allowed",
      );
      this.submitButtonTarget.classList.add("hover:bg-[#9EBE56]");
      this.submitButtonTarget.classList.remove("bg-[#E3E6E7]");
      this.submitButtonTarget.classList.add("bg-[#ABC764]");
    }
  }

  disableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed");
      this.submitButtonTarget.classList.remove("hover:bg-[#9EBE56]");
      this.submitButtonTarget.classList.add("bg-[#E3E6E7]");
      this.submitButtonTarget.classList.remove("bg-[#ABC764]");
    }
  }
}
